import { useContext } from 'react'
import { Navigate, useParams } from 'react-router-dom'

import { AuthContext } from '@contexts/Auth'
import useLocalStorage from '@hooks/useLocalStorage'
import { hasPermission } from '@utils/permission_helper'
import { PermissionCodeEnum } from '@models/permission'
import { useKeycloak } from '@react-keycloak/web'

type ProtectedRouteProps = {
	children: JSX.Element
	permissionCodes?: PermissionCodeEnum[]
}

export const ProtectedRoute = ({ children, permissionCodes }: ProtectedRouteProps) => {
	const { state: userState } = useContext(AuthContext)
	const { keycloak, initialized } = useKeycloak()
	const [isAdmin] = useLocalStorage<string>('admin', '')
	const { project_id } = useParams<string>()
	console.debug('project_id', project_id)

	if (!userState.completedInitiated) {
		return null
	}

	if (userState.userInfo.is_super_admin || isAdmin === 'true') return children
	if (permissionCodes === undefined || hasPermission(userState?.userInfo, permissionCodes))
		return children

	return <Navigate to="/401" />
}
